import i18next from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import { pseudoInstance } from './localizationHelpers';

i18next.use(pseudoInstance).use(reactI18nextModule).init({
  lng: 'en-US',
  fallbackLng: 'en-US',
  ns: ['translations'],
  defaultNS: 'translations',
  resources: {},
  debug: false,
  returnObjects: true,
  react: {
    wait: true,
    defaultTransParent: 'span'
  },
  postProcess: ['pseudo']
});

export default i18next;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-i18next/es/i18n.js
// module id = 635
// module chunks = 0